module.exports = __webpack_public_path__ + "static/media/paddycultivate.f2be1788.png";